import React, { memo } from 'react';
import styled from 'styled-components';

import BusIcon from 'assets/v2/BusIcon';
import { COLORS } from 'theme';
import { TRIP_TYPE_NAMES } from 'utils/constants';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.skyBlueDark};
    background: ${COLORS.skyBlueLight};
    border-color: ${COLORS.skyBlueDark};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.skyBlueDark};
    }
  }
`;

function PublicTransportationTripTypeTag(props) {
  return (
    <StyledTag
      label={TRIP_TYPE_NAMES.PUBLIC_TRANSPORTATION}
      icon={<BusIcon />}
      {...props}
    />
  );
}

export default memo(PublicTransportationTripTypeTag);
